import { useTranslation } from 'react-i18next'
import HeroSection from './components/HeroSection'
import FeaturesSection from './components/FeaturesSection'
import HotVideosSection from './components/HotVideosSection'
import CategoriesSection from './components/CategoriesSection'
import CTASection from './components/CTASection'
import SEOHead from '@/components/feature/SEOHead'

export default function Home() {
  const { t } = useTranslation('common')

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '快猫短视频',
        url: 'https://kuaikuaimao.com',
        description: t('footer.brandDesc'),
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: t('footer.phone'),
          contactType: 'customer service',
        },
      },
      {
        '@type': 'WebSite',
        name: '快猫短视频',
        url: 'https://kuaikuaimao.com',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://kuaikuaimao.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '快猫短视频-海量精彩内容随时刷',
        description: t('home.heroSubtitle'),
        url: 'https://kuaikuaimao.com',
        isPartOf: { '@type': 'WebSite', name: '快猫短视频' },
      },
    ],
  }

  return (
    <>
      <SEOHead
        title="快猫短视频-海量精彩内容随时刷"
        description={t('home.heroSubtitle')}
        keywords="快猫短视频,快猫短视频下载,快猫短视频app,快猫短视频官网,快猫短视频怎么玩,快猫短视频创作者"
        canonicalUrl="https://kuaikuaimao.com"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HotVideosSection />
        <CategoriesSection />
        <CTASection />
      </main>
    </>
  )
}